import { Create, TextInput, SimpleForm, SelectInput, required, ReferenceInput, useDataProvider, AutocompleteInput, NumberInput, minValue } from 'react-admin';
import HTMLEditorInput, { validHtml } from "../../common/inputs/HTMLEditorInput";
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const FaqCategoryRender = (choice: any) => `${choice.name}`;

const FAQCreate = () => {
    const [searchParams] = useSearchParams();
    const categoryId = searchParams.get('categoryId');
    const isDisabled = !!categoryId;
    const dataProvider = useDataProvider();

    const [faqCategory, setFaqCategory] = useState([]) as any;

    useEffect(() => {
        dataProvider
            .getList('faq-categories', {
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'name', order: 'ASC' },
                filter: {},
            })
            .then(({ data }) => setFaqCategory(data))
            .catch((error) => console.error(error));
    }, [dataProvider]);

    return <Create redirect={'/faqs'}>
        <SimpleForm
            defaultValues={{
                categoryId: categoryId
            }}
        >
            <TextInput source="question" fullWidth validate={[required()]} />
            <HTMLEditorInput source={'answer'} fullWidth validate={[required(), validHtml]} />
            <NumberInput
                source="displayOrder"
                fullWidth
                validate={[required(), minValue(1)]}
            />
            <AutocompleteInput
                source="categoryId"
                choices={faqCategory}
                optionText={FaqCategoryRender}
                fullWidth
                disabled={isDisabled}
                validate={[required()]}            />
        </SimpleForm>
    </Create>
}

export default FAQCreate;





